export default {
  title: 'Spoludlužníci',
  dialog: {
    title: 'Přidat spoludlužníka',
    close: 'Zavřít',
    submit: 'Přidat',
    error: 'Nepodařilo se vytvořit spoludlužníka',
    success: 'Spoludlužník byl vytvořen',
    errors: {
      default: 'Nepodařilo se vytvořit spoludlužníka',
      duplicitePhysicalEntity: 'Fyzická osoba s tímto rodným číslem již existuje',
      companyIdNotFound: 'IČO {companyId} nenalezeno',
      identityCardInvalid: 'Číslo občanského průkazu je neplatné.',
      birthNumber: 'Rodné číslo je neplatné.',
    },
  },
};
